
interface BannerAdProps {
  size?: 'large' | 'medium' | 'small';
  position?: 'top' | 'middle' | 'bottom';
  className?: string;
}

export default function BannerAd({ size = 'medium', position = 'middle', className = '' }: BannerAdProps) {
  const getSizeClasses = () => {
    switch (size) {
      case 'large':
        return 'h-32 md:h-40';
      case 'small':
        return 'h-20 md:h-24';
      default:
        return 'h-24 md:h-32';
    }
  };

  const adContent = {
    top: {
      title: '🏆 专业体育装备限时特惠',
      subtitle: '顶级运动品牌全场8折起，助力你的运动梦想',
      buttonText: '立即抢购',
      bgColor: 'from-blue-600 to-blue-800'
    },
    middle: {
      title: '📱 下载APP享受更多福利',
      subtitle: '独家赛事推送、VIP直播权限、专属优惠券',
      buttonText: '免费下载',
      bgColor: 'from-purple-600 to-pink-600'
    }
  };

  const content = adContent[position as keyof typeof adContent];

  // 如果没有对应的内容，不渲染任何内容
  if (!content) {
    return null;
  }

  return (
    <div className={`bg-gradient-to-r ${content.bgColor} rounded-lg overflow-hidden ${getSizeClasses()} ${className}`}>
      <div className="h-full flex items-center justify-between px-6 text-white">
        <div className="flex-1">
          <h3 className="font-bold text-lg md:text-xl mb-1">
            {content.title}
          </h3>
          <p className="text-sm md:text-base text-white/90">
            {content.subtitle}
          </p>
        </div>
        
        <div className="flex-shrink-0 ml-6">
          <button className="bg-white text-gray-900 px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base">
            {content.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
